import { isBooleanTrue, isListNotEmpty, isNotNullOrUndefined, isObjectNotEmpty, isStringEmpty, isStringNotEmpty, isStringNotEmptyOrZeroLength } from '../utils/objectUtils';
import { v4 as uuid } from 'uuid';
import { db } from '../firebase';
import { addObjectToChildArrayAndRefreshCount, removeObjectFromChildArrayAndRefreshCount, subCollectionCreate, subCollectionGetAll, subCollectionGetByDoubleQuery, subCollectionGetByParentIdAndSubId, subCollectionGetBySingleQuery, subCollectionGetByTripleQuery, subCollectionRemove, subCollectionUpdate, subCollectionUpdateField, subCollectionUpdateFields, updateObjectFieldInChildArray, updateObjectFieldsInChildArray, updateObjectInChildArrayAndRefreshCount } from '../utils/dbUtils';
import Insurance from './Insurance';
import { collectionGroup, endBefore, getCountFromServer, getDocs, limit, limitToLast, orderBy, query, startAfter, where } from 'firebase/firestore';
import { toLower } from 'lodash';
import Address from './Address';
import { addUserFile, getFileExt } from '../firebase/StorageService';

class UserInsurance {
	static collectionName = 'users';
	static subCollectionName = 'insurances';

	id = uuid();
	userId = null;
	subscriberId = null;

	rank = 'OTHER';
	hierarchy = 'UNKNOWN';
	status = 'UNKNOWN';
	isMedicare = false;
	isMedicaid = false;

	firstName = null;
	firstNameLower = null;
	middleName = null;
	lastName = null;
	lastNameLower = null;
	suffix = null;

	gender = null;
	dateOfBirth = null;

	socialSecurityNumber = null;
	socialSecurityNumberLastFour = null;

	patientPhone = null;
	patientAddress = new Address(null).toDto();
	relationshipToSubscriber = 'MEMBER';

	insurancePhone = null;
	insuranceAddress = new Address(null).toDto();

	subscriberFirstName = null;
	subscriberLastName = null;
	subscriberPhone = null;
	subscriberAddress = new Address(null).toDto();

	payerName = null;
	payerCode = null;
	planName = null;
	planNumber = null;
	groupName = null;
	groupNumber = null;
	planType = null;
	policyType = null;

	rxBin = null;
	rxPcn = null;
	rxGroup = null;

	effectiveFromDate = null;
	effectiveToDate = null;

	insuranceInfo = null;

	frontPhotoRefId = null;
	#frontPhoto = null;
	backPhotoRefId = null;
	#backPhoto = null;

	constructor(insurance) {
		if (isObjectNotEmpty(insurance)) {
			if (isStringNotEmpty(insurance.id)) { this.id = insurance.id; }
			if (isStringNotEmpty(insurance.userId)) { this.userId = insurance.userId; }
			if (isStringNotEmpty(insurance.subscriberId)) { this.subscriberId = insurance.subscriberId; }

			if (isStringNotEmpty(insurance.rank)) { this.rank = insurance.rank; }
			if (isStringNotEmpty(insurance.hierarchy)) { this.hierarchy = insurance.hierarchy; }
			if (isStringNotEmpty(insurance.status)) { this.status = insurance.status; }
			if (isBooleanTrue(insurance.isMedicare)) { this.isMedicare = true; }
			if (isBooleanTrue(insurance.isMedicaid)) { this.isMedicaid = true; }

			if (isStringNotEmpty(insurance.firstName)) {
				this.firstName = insurance.firstName;
				this.firstNameLower = toLower(insurance.firstName);
			}
			if (isStringNotEmpty(insurance.lastName)) {
				this.lastName = insurance.lastName;
				this.lastNameLower = toLower(insurance.lastName);
			}
			if (isStringNotEmpty(insurance.middleName)) { this.middleName = insurance.middleName; }
			if (isStringNotEmpty(insurance.suffix)) { this.suffix = insurance.suffix; }

			if (isStringNotEmpty(insurance.gender)) { this.gender = insurance.gender; }
			if (isStringNotEmpty(insurance.dateOfBirth)) { this.dateOfBirth = insurance.dateOfBirth; }

			if (isStringNotEmpty(insurance.socialSecurityNumber)) { this.socialSecurityNumber = insurance.socialSecurityNumber; }
			if (isStringNotEmpty(insurance.socialSecurityNumberLastFour)) { this.socialSecurityNumberLastFour = insurance.socialSecurityNumberLastFour; }

			if (isStringNotEmpty(insurance.patientPhone)) { this.patientPhone = insurance.patientPhone; }
			if (isObjectNotEmpty(insurance.patientAddress)) { this.patientAddress = new Address(insurance.patientAddress).toDto(); }
			if (isStringNotEmpty(insurance.relationshipToSubscriber)) { this.relationshipToSubscriber = insurance.relationshipToSubscriber; }

			if (isStringNotEmpty(insurance.insurancePhone)) { this.insurancePhone = insurance.insurancePhone; }
			if (isObjectNotEmpty(insurance.insuranceAddress)) { this.insuranceAddress = new Address(insurance.insuranceAddress).toDto(); }

			if (isStringNotEmpty(insurance.subscriberFirstName)) { this.subscriberFirstName = insurance.subscriberFirstName; }
			if (isStringNotEmpty(insurance.subscriberLastName)) { this.subscriberLastName = insurance.subscriberLastName; }
			if (isStringNotEmpty(insurance.subscriberPhone)) { this.subscriberPhone = insurance.subscriberPhone; }
			if (isObjectNotEmpty(insurance.subscriberAddress)) { this.subscriberAddress = new Address(insurance.subscriberAddress).toDto(); }

			if (isStringNotEmpty(insurance.payerName)) { this.payerName = insurance.payerName; }
			if (isStringNotEmpty(insurance.payerCode)) { this.payerCode = insurance.payerCode; }
			if (isStringNotEmpty(insurance.planName)) { this.planName = insurance.planName; }
			if (isStringNotEmpty(insurance.planNumber)) { this.planNumber = insurance.planNumber; }
			if (isStringNotEmpty(insurance.groupName)) { this.groupName = insurance.groupName; }
			if (isStringNotEmpty(insurance.groupNumber)) { this.groupNumber = insurance.groupNumber; }
			if (isStringNotEmpty(insurance.planType)) { this.planType = insurance.planType; }
			if (isStringNotEmpty(insurance.policyType)) { this.policyType = insurance.policyType; }

			if (isStringNotEmpty(insurance.rxBin)) { this.rxBin = insurance.rxBin; }
			if (isStringNotEmpty(insurance.rxPcn)) { this.rxPcn = insurance.rxPcn; }
			if (isStringNotEmpty(insurance.rxGroup)) { this.rxGroup = insurance.rxGroup; }

			if (isStringNotEmpty(insurance.effectiveFromDate)) { this.effectiveFromDate = insurance.effectiveFromDate; }
			if (isStringNotEmpty(insurance.effectiveToDate)) { this.effectiveToDate = insurance.effectiveToDate; }

			if (isObjectNotEmpty(insurance.insuranceInfo)) { this.insuranceInfo = insurance.insuranceInfo; }

			if (isStringNotEmpty(insurance.frontPhotoRefId)) { this.frontPhotoRefId = insurance.frontPhotoRefId; }
			if (isNotNullOrUndefined(insurance.frontPhoto)) { this.#frontPhoto = insurance.frontPhoto; }
			if (isStringNotEmpty(insurance.backPhotoRefId)) { this.backPhotoRefId = insurance.backPhotoRefId; }
			if (isNotNullOrUndefined(insurance.backPhoto)) { this.#backPhoto = insurance.backPhoto; }
		}
	}

	toDto = () => {
		return {
			id: this.id,
			userId: this.userId,
			subscriberId: this.subscriberId,

			rank: this.rank,
			hierarchy: this.hierarchy,
			status: this.status,
			isMedicare: this.isMedicare,
			isMedicaid: this.isMedicaid,

			firstName: this.firstName,
			firstNameLower: this.firstNameLower,
			middleName: this.middleName,
			lastName: this.lastName,
			lastNameLower: this.lastNameLower,
			suffix: this.suffix,

			gender: this.gender,
			dateOfBirth: this.dateOfBirth,

			socialSecurityNumber: this.socialSecurityNumber,
			socialSecurityNumberLastFour: this.socialSecurityNumberLastFour,

			patientPhone: this.patientPhone,
			patientAddress: this.patientAddress,
			relationshipToSubscriber: this.relationshipToSubscriber,

			insurancePhone: this.insurancePhone,
			insuranceAddress: this.insuranceAddress,

			subscriberFirstName: this.subscriberFirstName,
			subscriberLastName: this.subscriberLastName,
			subscriberPhone: this.subscriberPhone,
			subscriberAddress: this.subscriberAddress,

			payerName: this.payerName,
			payerCode: this.payerCode,
			planName: this.planName,
			planNumber: this.planNumber,
			groupName: this.groupName,
			groupNumber: this.groupNumber,
			planType: this.planType,
			policyType: this.policyType,

			rxBin: this.rxBin,
			rxPcn: this.rxPcn,
			rxGroup: this.rxGroup,

			effectiveFromDate: this.effectiveFromDate,
			effectiveToDate: this.effectiveToDate,

			insuranceInfo: this.insuranceInfo,

			frontPhotoRefId: this.frontPhotoRefId,
			backPhotoRefId: this.backPhotoRefId
		};
	}

	isValid = () => {
		if (isStringEmpty(this.userId)) {
			throw new Error('userId is required.');
		}

		return true;
	}

	static uploadFrontPhoto = async (userId, frontPhoto) => {
		if (isNotNullOrUndefined(frontPhoto)) {
			const fileId = uuid();
			const fileName = fileId + getFileExt(frontPhoto.name);
			const uploadRes = await addUserFile(frontPhoto, 'documents', fileName, 'INSURANCE_CARD_FRONT', 'PENDING', userId, []);
			// console.log(uploadRes);
			if (isObjectNotEmpty(uploadRes)) {
				return uploadRes.ref.fullPath;
			}
		}

		return null;
	}

	static uploadBackPhoto = async (userId, backPhoto) => {
		if (isNotNullOrUndefined(backPhoto)) {
			const fileId = uuid();
			const fileName = fileId + getFileExt(backPhoto.name);
			const uploadRes = await addUserFile(backPhoto, 'documents', fileName, 'INSURANCE_CARD_BACK', 'PENDING', userId, []);
			// console.log(uploadRes);
			if (isObjectNotEmpty(uploadRes)) {
				return uploadRes.ref.fullPath;
			}
		}

		return null;
	}

	create = async () => {
		if (this.isValid()) {
			this.frontPhotoRefId = await UserInsurance.uploadFrontPhoto(this.userId, this.#frontPhoto);
			this.backPhotoRefId = await UserInsurance.uploadBackPhoto(this.userId, this.#backPhoto);

			const newInsurance = await subCollectionCreate(UserInsurance.collectionName, this.userId, UserInsurance.subCollectionName, this.id, this.toDto());
			if (isObjectNotEmpty(newInsurance)) {
				// add to user insurance array
				const success = await addObjectToChildArrayAndRefreshCount(UserInsurance.collectionName, this.userId, 'insurances', 'id', new Insurance(this.toDto()).toDto(), 'insurancesCount');
				if (isBooleanTrue(success)) {
					return newInsurance;
				}
			}
		}

		return null;
	};

	static updateField = async (userId, insuranceId, fieldName, newValue) => {
		if (isStringNotEmpty(userId) && isStringNotEmpty(insuranceId)) {
			const success = await subCollectionUpdateField(UserInsurance.collectionName, userId, UserInsurance.subCollectionName, insuranceId, fieldName, newValue);
			if (isBooleanTrue(success)) {
				// only update the field in Insurance if it isn't insuranceInfo since it is not part of the Insurance model
				if (fieldName !== 'insuranceInfo') {
					return await updateObjectFieldInChildArray(UserInsurance.collectionName, userId, 'insurances', 'id', insuranceId, fieldName, newValue);
				} else {
					return true;
				}
			}
		}

		return false;
	}

	static updateFields = async (userId, insuranceId, updatedFields) => {
		if (isStringNotEmpty(userId) && isStringNotEmpty(insuranceId)) {
			if (updatedFields['firstName'] !== undefined) {
				updatedFields['firstNameLower'] = toLower(updatedFields['firstName']);
			}
			if (updatedFields['lastName'] !== undefined) {
				updatedFields['lastNameLower'] = toLower(updatedFields['lastName']);
			}

			const success = await subCollectionUpdateFields(UserInsurance.collectionName, userId, UserInsurance.subCollectionName, insuranceId, updatedFields);
			if (isBooleanTrue(success)) {
				// remove insuranceInfo from copy of Insurance fields since it isn't in the Insurance model
				let copyOfUpdatedFields = { ...updatedFields };
				if (copyOfUpdatedFields['insuranceInfo'] !== undefined) {
					delete copyOfUpdatedFields['insuranceInfo'];
				}

				return await updateObjectFieldsInChildArray(UserInsurance.collectionName, userId, 'insurances', 'id', insuranceId, copyOfUpdatedFields);
			}
		}

		return false;
	}

	static update = async (userId, insuranceId, updatedInsurance, oldInsurance) => {
		let updatedObj = new UserInsurance(updatedInsurance);
		if (userId === updatedInsurance.userId && insuranceId === updatedInsurance.id) {
			if (isNotNullOrUndefined(updatedObj.#frontPhoto)) {
				updatedObj.frontPhotoRefId = await UserInsurance.uploadFrontPhoto(userId, updatedObj.#frontPhoto);
			}
			if (isNotNullOrUndefined(updatedObj.#backPhoto)) {
				updatedObj.backPhotoRefId = await UserInsurance.uploadBackPhoto(userId, updatedObj.#backPhoto);
			}

			const success = await subCollectionUpdate(UserInsurance.collectionName, userId, UserInsurance.subCollectionName, insuranceId, updatedObj.toDto());
			if (isBooleanTrue(success)) {
				// remove insuranceInfo from copy of Insurance fields since it isn't in the Insurance model
				let copyOfUpdatedObj = { ...updatedObj.toDto() };
				if (copyOfUpdatedObj['insuranceInfo'] !== undefined) {
					delete copyOfUpdatedObj['insuranceInfo'];
				}

				await updateObjectInChildArrayAndRefreshCount(UserInsurance.collectionName, userId, 'insurances', 'id', copyOfUpdatedObj, 'insurancesCount');

				return { ...oldInsurance, ...updatedObj.toDto() };
			}
		} else {
			throw new Error('userId and insuranceId do not match the id and userId fields of the updated insurance record.')
		}

		return null;
	}

	static delete = async (userId, insuranceId) => {
		if (isStringNotEmpty(userId) && isStringNotEmpty(insuranceId)) {
			const success = await subCollectionRemove(UserInsurance.collectionName, userId, UserInsurance.subCollectionName, insuranceId);
			if (isBooleanTrue(success)) {
				return await removeObjectFromChildArrayAndRefreshCount(UserInsurance.collectionName, userId, 'insurances', 'id', insuranceId, 'insurancesCount');
			}
		}

		return false;
	}

	static getById = async (userId, insuranceId) => {
		if (isStringNotEmpty(userId) && isStringNotEmpty(insuranceId)) {
			return await subCollectionGetByParentIdAndSubId(UserInsurance.collectionName, userId, UserInsurance.subCollectionName, insuranceId);
		}

		return null;
	}

	static getAll = async () => {
		return await subCollectionGetAll(UserInsurance.subCollectionName);
	}

	static getByField = async (fieldName, fieldValue, comparer = '==') => {
		return await subCollectionGetBySingleQuery(UserInsurance.subCollectionName, fieldName, fieldValue, comparer);
	}

	static getByUserId = async (userId) => {
		return await subCollectionGetBySingleQuery(UserInsurance.subCollectionName, 'userId', userId, '==');
	}

	static getBySubscriberId = async (subscriberId) => {
		return await subCollectionGetBySingleQuery(UserInsurance.subCollectionName, 'subscriberId', subscriberId, '==');
	}

	static getBySubscriberIdAndDateOfBirthAndFirstName = async (subscriberId, dateOfBirth, firstName) => {
		return await subCollectionGetByTripleQuery(UserInsurance.subCollectionName, 'subscriberId', subscriberId, '==', 'dateOfBirth', dateOfBirth, '==', 'firstNameLower', toLower(firstName), '==');
	}

	static getByUserIdAndRank = async (userId, rank) => {
		return await subCollectionGetByDoubleQuery(UserInsurance.subCollectionName, 'userId', userId, '==', 'rank', rank, '==');
	}

	static getInsuranceCount = async (userId = null, rank = null, status = null, planType = null, isMedicare = null, isMedicaid = null, state = null) => {
		let queryConstraints = [];

		if (isStringNotEmptyOrZeroLength(userId)) {
			queryConstraints.push(where('userId', '==', userId));
		}

		if (isListNotEmpty(rank)) {
			queryConstraints.push(where('rank', 'in', rank));
		} else if (isStringNotEmptyOrZeroLength(rank)) {
			queryConstraints.push(where('rank', '==', rank));
		}

		if (isListNotEmpty(status)) {
			queryConstraints.push(where('status', 'in', status));
		} else if (isStringNotEmptyOrZeroLength(status)) {
			queryConstraints.push(where('status', '==', status));
		}

		if (isListNotEmpty(planType)) {
			queryConstraints.push(where('planType', 'in', planType));
		} else if (isStringNotEmptyOrZeroLength(planType)) {
			queryConstraints.push(where('planType', '==', planType));
		}

		if (isBooleanTrue(isMedicare)) {
			queryConstraints.push(where('isMedicare', '==', true));
		}
		if (isBooleanTrue(isMedicaid)) {
			queryConstraints.push(where('isMedicaid', '==', true));
		}

		if (isListNotEmpty(state)) {
			queryConstraints.push(where('patientAddress.state', 'in', state));
		} else if (isStringNotEmptyOrZeroLength(state)) {
			queryConstraints.push(where('patientAddress.state', '==', state));
		}

		// console.log(queryConstraints);

		let q = query(collectionGroup(db, UserInsurance.subCollectionName), ...queryConstraints);

		const snapShot = await getCountFromServer(q);
		// console.log(snapShot.data());

		return snapShot.data().count;
	}

	static getInsurancesPaginated = async (userId = null, rank = null, status = null, planType = null, isMedicare = null, isMedicaid = null, state = null, pageSize = 25, firstVisible, lastVisible, orderByField = 'createdAt') => {
		let queryConstraints = [];

		if (isStringNotEmptyOrZeroLength(userId)) {
			queryConstraints.push(where('userId', '==', userId));
		}

		if (isListNotEmpty(rank)) {
			queryConstraints.push(where('rank', 'in', rank));
		} else if (isStringNotEmptyOrZeroLength(rank)) {
			queryConstraints.push(where('rank', '==', rank));
		}

		if (isListNotEmpty(status)) {
			queryConstraints.push(where('status', 'in', status));
		} else if (isStringNotEmptyOrZeroLength(status)) {
			queryConstraints.push(where('status', '==', status));
		}

		if (isListNotEmpty(planType)) {
			queryConstraints.push(where('planType', 'in', planType));
		} else if (isStringNotEmptyOrZeroLength(planType)) {
			queryConstraints.push(where('planType', '==', planType));
		}

		if (isBooleanTrue(isMedicare)) {
			queryConstraints.push(where('isMedicare', '==', true));
		}
		if (isBooleanTrue(isMedicaid)) {
			queryConstraints.push(where('isMedicaid', '==', true));
		}

		if (isListNotEmpty(state)) {
			queryConstraints.push(where('patientAddress.state', 'in', state));
		} else if (isStringNotEmptyOrZeroLength(state)) {
			queryConstraints.push(where('patientAddress.state', '==', state));
		}

		let q = null;
		if (isStringNotEmpty(firstVisible)) {
			q = query(collectionGroup(db, UserInsurance.subCollectionName), ...queryConstraints, orderBy(orderByField, 'asc'), orderBy('__name__', 'asc'), limitToLast(pageSize), endBefore(firstVisible[orderByField], firstVisible['id']));
		} else if (isStringNotEmpty(lastVisible)) {
			q = query(collectionGroup(db, UserInsurance.subCollectionName), ...queryConstraints, orderBy(orderByField, 'asc'), orderBy('__name__', 'asc'), limit(pageSize), startAfter(lastVisible[orderByField], lastVisible['id']));
		} else {
			q = query(collectionGroup(db, UserInsurance.subCollectionName), ...queryConstraints, orderBy(orderByField, 'asc'), orderBy('__name__', 'asc'), limit(pageSize));
		}

		const snapShot = await getDocs(q);
		return snapShot.docs.map((doc) => {
			return {
				id: doc.id, // append document id to each document
				...doc.data()
			};
		});
	}

	static getInsurances = async (userId = null, rank = null, status = null, planType = null, isMedicare = null, isMedicaid = null, state = null) => {
		let allRecords = [];
		try {
			let next = null;

			let totalCount = await UserInsurance.getInsuranceCount(userId, rank, status, planType, isMedicare, isMedicaid, state);
			let totalPages = Math.ceil(totalCount / 10000.0);
			// console.log('totalCount: ' + totalCount);
			// console.log('totalPages: ' + totalPages);
			let pages = [];
			for (let i = 0; i < totalPages; i++) {
				pages.push(i + 1);
			}
			for (const page of pages) {
				// console.log('starting page ' + page);

				let list = await UserInsurance.getInsurancesPaginated(userId, rank, status, planType, isMedicare, isMedicaid, state, 10000, null, next, 'createdAt');

				// console.log(list.length);
				allRecords = [...allRecords, ...list];

				// console.log(allRecords.length);

				// console.log('go to next page');
				next = list[list.length - 1];
			}
		} catch (error) {
			console.log(error);
		}

		return allRecords;
	}
}

export default UserInsurance;